export const needAConferenceRoomValue: { name: string; key: boolean }[] = [
  {
    name: 'Yes',
    key: true,
  },
  {
    name: 'No',
    key: false,
  },
];

export const needAConferenceRoomOptions = needAConferenceRoomValue.map(t => ({
  value: t.key,
  label: t.name,
}));
